import { formOptions } from '@tanstack/react-form';
import { z } from 'zod';

// existingTitles를 포함한 title Zod 스키마 팩토리
export const createTitleSchema = (existingTitles: string[] = []) =>
  z
    .string()
    .min(1, { message: 'Please enter a title' })
    .max(20, { message: 'Title must be 20 characters or less' })
    .refine((val) => !existingTitles.includes(val), {
      message: 'A signal with this title already exists',
    });

export const definitionSchema = z
  .string()
  .min(1, { message: 'Please enter a definition' });

// existingTitles를 포함한 폼 전체 Zod 스키마 팩토리
export const createSignalFormSchema = (existingTitles: string[] = []) =>
  z.object({
    title: createTitleSchema(existingTitles),
    definition: definitionSchema,
  });

export type CreateSignalFormData = z.infer<
  ReturnType<typeof createSignalFormSchema>
>;

// 폼 전체 Zod 유효성 검사
const validateCreateSignalForm = ({
  value,
}: {
  value: CreateSignalFormData;
}) => {
  const result = createSignalFormSchema().safeParse(value);
  if (result.success) return undefined;

  return result.error.issues.map((issue) => ({
    path: issue.path,
    message: issue.message,
  }));
};

export const createSignalFormOptions = formOptions({
  defaultValues: {
    title: '',
    definition: '',
  },
  validators: {
    onSubmit: validateCreateSignalForm,
  },
});
